// Psychologist/utils.ts
import {getYearWord as getYearWordOriginal} from '../../Utils/getYearWord';

export function calculateAge(birthDate: string): number {
    const birth = new Date(birthDate);
    const diff = Date.now() - birth.getTime();
    const ageDate = new Date(diff);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function calculateExperienceYears(experienceStart: string | Date): number {
    const start = new Date(experienceStart);
    const diff = Date.now() - start.getTime();
    const experienceDate = new Date(diff);
    return Math.abs(experienceDate.getUTCFullYear() - 1970);
}

export function getYearWord(years: number): string {
    // Допустим, эта функция была уже определена или импортирована
    // В оригинальном коде она импортируется из 'utils/getYearWord'
    return getYearWordOriginal(years);
}

// Удаляет параметры из URL
export function removeSettingsParamsFromURL(navigate: Function) {
    const url = new URL(window.location.href);
    url.searchParams.delete('reservation_paid');
    url.searchParams.delete('config');
    navigate(url.pathname + url.search, {replace: true});
    window.location.reload();
}